import * as React from "react";
import type { SVGProps } from "react";
const SvgWallet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#wallet_svg__a)">
      <path d="M6.31 10.04c-.21 0-.43-.07-.61-.21a.99.99 0 0 1-.18-1.4l4.93-6.42c.87-1.13 2.5-1.35 3.63-.48l4.14 3.18c.55.42.9 1.03.99 1.72s-.09 1.37-.51 1.91l-.96 1.25a.99.99 0 0 1-1.4.18.99.99 0 0 1-.18-1.4l.96-1.24c.1-.12.14-.28.12-.44a.57.57 0 0 0-.23-.39l-4.14-3.18a.59.59 0 0 0-.83.11L7.11 9.65c-.2.26-.49.39-.79.39z" />
      <path d="M10.8 9.75c-.21 0-.43-.07-.61-.21a.99.99 0 0 1-.18-1.4l3.88-5.05c.34-.44.96-.52 1.4-.18s.52.96.18 1.4l-3.88 5.05c-.2.26-.49.39-.79.39" />
      <path d="M18 22H3.96C2.88 22 2 21.12 2 20.04V9.94C2 8.87 2.87 8 3.94 8H18c1.1 0 2 .9 2 2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H3.94L4 20.04 18 20v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 1.1-.9 2-2 2" />
      <path d="M20 19h-3c-1.65 0-3-1.35-3-3v-2c0-1.65 1.35-3 3-3h3c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2m-3-6c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h3v-4z" />
      <path d="M18 16c-.13 0-.26-.02-.38-.08q-.18-.075-.33-.21c-.09-.1-.16-.2-.21-.33A1 1 0 0 1 17 15c0-.26.11-.52.29-.71q.15-.135.33-.21c.37-.16.81-.07 1.09.21.18.19.29.45.29.71 0 .13-.02.26-.08.38-.05.13-.12.23-.21.33-.19.18-.45.29-.71.29" />
    </g>
    <defs>
      <clipPath id="wallet_svg__a">
        <path fill="#fff" d="M2 1h20v21H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWallet;
